module.exports = __webpack_public_path__ + "static/media/plus_addTag.73f87c10.svg";